import { DateTime } from "luxon";

interface IHeaderField {
  key: string;
  label?: string;
  value?: any | ((data: any) => any);
}

interface IRowField<T = any> {
  key: string;
  label?: string;
  transform?: (value: any, item: T) => any;
  value?: any | ((item: T) => any);    
}

export interface IExportConfig<T = any> {
  fileName: string
  rootName?: string;
  headerConfig?: {
    fields: IHeaderField[];
    dataSource?: any;
  };
  rowConfig: {
    fields: IRowField<T>[];
  };
}

// Универсальная функция для экспорта в XML
export const exportGenericXml = <T>(
  data: T[],
  config: IExportConfig<T>,
  getAdditionalData?: () => any
) => {
  const {
    rootName = 'XML',
    headerConfig,
    rowConfig
  } = config;

  // Генерация даты
  const dateNow = DateTime.now().toFormat('yyyy-MM-ddTHH:mm:ss');

  // Получение значения с поддержкой функции
  const getValue = (field: IHeaderField | IRowField<T>, source: any): any => {
        if (field.value !== undefined) {
        // Если value - функция, вызываем её
        if (typeof field.value === 'function') {
            return field.value(source);
        }
        return field.value;
        }
        // Иначе берем из источника по ключу
        return source[field.key];
    };

    // Формирование заголовка
    const generateHeader = () => {
        if (!headerConfig) return '';

        const headerData = headerConfig.dataSource || {};
        
        // Если нужно получить дополнительные данные
        if (getAdditionalData) {
        const additionalData = getAdditionalData();
        Object.assign(headerData, additionalData);
        }

        let headerRows = '';
        
        headerConfig.fields.forEach((field) => {
        const value = getValue(field, headerData);
        const tagName = field.label || field.key;
        headerRows += `<${tagName}>${value ?? ''}</${tagName}>`;
        });

        return `<HEADER><ROW>${headerRows}</ROW></HEADER>`;
    };

    // Формирование строк данных
    const generateRows = () => {
        let rows = '';

        data.forEach((item) => {
        let rowContent = '';
        
        rowConfig.fields.forEach((field) => {
            let value = getValue(field, item);

            if (field.transform) {
            value = field.transform(value, item);
            }
            
            const tagName = field.label || field.key;
            rowContent += `<${tagName}>${value ?? ''}</${tagName}>`;
        });

        rows += `<ROW>${rowContent}</ROW>`;
        });

        return `<ROWS>${rows}</ROWS>`;
    };

    // Сборка XML
    let xml = `<${rootName}>`;
    xml += generateHeader();
    xml += generateRows();
    xml += `</${rootName}>`;

    // Экспорт
    ExportXML(xml, dateNow,config.fileName);
};

const ExportXML = (data, date: string, nameFile: string) =>{
    const blob = new Blob([data], {type: 'octet-stream'})    
    const href = URL.createObjectURL(blob)
    const a = Object.assign(document.createElement("a"), {
        href,
        style: "display:none",
        download: `${nameFile} ${date}.xml`,
    })
    document.body.appendChild(a)
    a.click();
    URL.revokeObjectURL(href)
    a.remove();
}